import React, { useEffect, useState } from "react";
import { withRouter, useHistory, useLocation } from "react-router-dom";
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import _ from "lodash";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../../config";
import getSearchParam from "../../../../../../../hooks/UrlSearchParam";
import "./MatchupLocations.css";
import { COLORS } from '../../../../../../../Util/helper';
import SortableList, { SortableItem } from "react-easy-sort";
import { messages } from '../../../../../../../messages';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import WarningDialogue from '../../../../../../../Util/WarningDialogue';

function MatchupLocations(props) {
  const history = useHistory();
  const [leagueId, setLeagueId] = useState(0);
  const [locations, setLocations] = useState([]);
  const [matches, setMatches] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [division, setDivision] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const confirmSchedule = props.confirmSchedule || false;
  const reSchedule = props.reSchedule || false;
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');

  useEffect(() => {
    const leagueId_ = getSearchParam(props.location).get('leagueId');
    if (leagueId_ > 0) {
      setLeagueId(leagueId_);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (leagueId > 0) {
      getLocationMatchup();
    }
    //eslint-disable-next-line
  }, [leagueId]);

  useEffect(() => {
    if (confirmSchedule) {
      crateSchedule()
    }
    //eslint-disable-next-line
  }, [confirmSchedule]);

  useEffect(() => {
    if (reSchedule) {
      getLocationMatchup()
    }
    //eslint-disable-next-line
  }, [reSchedule]);

  const getLocationMatchup = () => {
    axiosApi.get(`${config.apiUrl}/leagues/schedule/location/matchup/${leagueId}/${reSchedule}`)
      .then((response) => {
        setErrorMessage(response.data.message);
        if (response.data.status === 'success') {
          if (response.data && response.data.teamData) {
            response.data.teamData = response.data.teamData.map((v, i) => ({ ...v, color: COLORS[i] }))
          }
          setTeamData(response.data.teamData);
          setLocations(response.data.data ? response.data.data.locations : []);
          setMatches(response.data.data ? response.data.data.matches : []);
          setDivision(response.data.divisionData ? response.data.divisionData : []);
        }
        if (response.data.conflicts) {
          setOpenWarningPopup(true);
          setPopUpContent({
            header: 'Warning',
            description: messages.conflictedFields,
            icon: faExclamationCircle,
            action: () => {
              setOpenWarningPopup(false);
              setTimeout(() => {
                history.push({
                  pathname: `/admin/leagues/teams/weekly-match`,
                  search: `?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}&selected=true` : ''}`,
                })
              }, 100);
            }
          });
        }
        if (reSchedule) {
          props.emit(true);
        }
      }).catch(err => {
        if (reSchedule) {
          props.emit(true);
        }
      })
  }

  const crateSchedule = async () => {
    if (matches.length) {
      try {
        axiosApi.post(`${config.apiUrl}/leagues/schedule/location/confirm`, { league_id: leagueId, matches })
      } finally {
        props.emit(true);
      }
    }
  }

  const teamName = (id) => {
    let name = 'N/A';
    if (id && teamData) {
      const findTeam = teamData.find(x => +x.id === +id);
      if (findTeam) {
        name = `${findTeam.name} (${findTeam.preferred_time.charAt(0).toUpperCase()})`;
      }
    }
    return name;
  }

  const colorCode = (id) => {
    let color = '';
    if (id && teamData) {
      color = teamData.find(x => +x.id === +id) ? teamData.find(x => +x.id === +id).color : '';
    }
    return color;
  }

  const checkConflicts = (id1, id2, cTime, cTeam) => {
    let conflict = '';
    if (id1 && id2 && teamData) {
      let preferredTime1 = teamData.find(x => +x.id === +id1) ? teamData.find(x => +x.id === +id1).preferred_time : '';
      let preferredTime2 = teamData.find(x => +x.id === +id2) ? teamData.find(x => +x.id === +id2).preferred_time : '';
      if (preferredTime1 && preferredTime2) {
        preferredTime1 = preferredTime1.charAt(0).toUpperCase();
        preferredTime2 = preferredTime2.charAt(0).toUpperCase();
        if (preferredTime1 !== 'B' && preferredTime2 !== 'B') {
          if (preferredTime1 !== preferredTime2) {
            let switchCaseTeam = preferredTime1;
            if (cTeam === 2) {
              switchCaseTeam = preferredTime2;
            }
            switch (switchCaseTeam) {
              case 'E':
                if (cTime.includes('PM')) {
                  conflict = <sup style={{ color: 'red', fontSize: 'medium' }}>*</sup>;
                }
                break;
              case 'L':
                if (cTime.includes('AM')) {
                  conflict = <sup style={{ color: 'red', fontSize: 'medium' }}>*</sup>;
                }
                break;
              default:
                break;
            }
          }
        }
      }
    }
    return conflict;
  }

  const onSortEnd = (oldIndex, newIndex) => {
    const fieldIds = [].concat.apply([], locations.map(x => x.fields.map(y => y.field_id)));
    const sourceIndex = Math.floor(oldIndex / fieldIds.length);
    const destIndex = Math.floor(newIndex / fieldIds.length);
    const items = [...matches];
    if (matches[sourceIndex] && matches[destIndex]) {
      if (sourceIndex === destIndex) {
        if (sourceIndex > 0) {
          oldIndex = Math.ceil(oldIndex % fieldIds.length);
        }
        if (destIndex > 0) {
          newIndex = Math.ceil(newIndex % fieldIds.length);
        }
        let teamOrder = [...matches[sourceIndex].schedule];
        const sourceObj = { ...teamOrder[oldIndex] };
        const destObj = { ...teamOrder[newIndex] };
        if (!_.isEmpty(sourceObj) && !_.isEmpty(destObj)) {
          teamOrder[oldIndex].team1_id = destObj.team1_id;
          teamOrder[oldIndex].team2_id = destObj.team2_id;
          teamOrder[newIndex].team1_id = sourceObj.team1_id;
          teamOrder[newIndex].team2_id = sourceObj.team2_id;
          items[sourceIndex].schedule = [...teamOrder];
          setMatches(items);
        }
      } else {
        oldIndex = Math.ceil(oldIndex % fieldIds.length);
        newIndex = Math.ceil(newIndex % fieldIds.length);
        let sourceTeamOrder = [...matches[sourceIndex].schedule];
        let destTeamOrder = [...matches[destIndex].schedule];
        const sourceObj = { ...sourceTeamOrder[oldIndex] };
        const destObj = { ...destTeamOrder[newIndex] };
        if (!_.isEmpty(sourceObj) && !_.isEmpty(destObj)) {
          sourceTeamOrder[oldIndex].team1_id = destObj.team1_id;
          sourceTeamOrder[oldIndex].team2_id = destObj.team2_id;
          destTeamOrder[newIndex].team1_id = sourceObj.team1_id;
          destTeamOrder[newIndex].team2_id = sourceObj.team2_id;
          items[sourceIndex].schedule = [...sourceTeamOrder];
          items[destIndex].schedule = [...destTeamOrder];
          setMatches(items);
        }
      }
    }
  }

  return (
    <>
      {
        locations &&
        matches &&
        locations.length > 0 &&
        <div className="matchup-location schedule-create-block">
          <h2>Matchup Locations</h2>
          <p>Drag and drop matchups to change locations</p>
          <div className="create-schedule-innner">
            <div className="schedule-create-row headingblock">
              <div className="schedule-create-col col1"></div>
              <div className="schedule-create-col col2"></div>
              {
                locations.map((loc, i) => (
                  <div className={`schedule-parent-col col${i + 3}`} key={`${loc.id}-${i}`}>
                    <div className="schedule-name">{loc.location_name}</div>
                    <div className="schedule-outer-col">
                      {
                        loc &&
                        loc.fields &&
                        loc.fields.map((field) => (
                          <div className="schedule-inner-col" key={`${field.field_id}-${loc.id}`}>
                            {field.field_name}
                          </div>
                        ))
                      }
                    </div>
                  </div>
                ))
              }
            </div>
            <SortableList onSortEnd={onSortEnd} draggedItemClassName="draggableLocation">
              <div className="schedule-create-body">
                {matches.map((val, i) => (
                  <div className="schedule-create-row row1" key={val.id}>
                    <div className="schedule-create-col col1">
                      {val.date}
                    </div>
                    <div className="schedule-create-col col2">
                      {val.time ? val.time : 'N/A'}
                    </div>
                    <div className="schedule-inner-col">
                      {
                        val.schedule &&
                        val.schedule.map((match, _index) => (

                          <SortableItem key={match?.id}>
                            <div className={`schedule-create-col col${_index + 3}`} key={match?.id}>
                              <div  >
                                <span style={{ background: colorCode(match?.team1_id) }}></span>
                                {
                                  match?.team1_id > 0 &&
                                  match?.team2_id > 0 &&
                                  checkConflicts(match?.team1_id, match?.team2_id, val.time, 1)
                                }
                                <p className="team-name">{teamName(match?.team1_id)}</p>
                              </div>
                              <div>
                                <span style={{ background: colorCode(match?.team2_id) }}></span>
                                {
                                  match?.team1_id > 0 &&
                                  match?.team2_id > 0 &&
                                  checkConflicts(match?.team1_id, match?.team2_id, val.time, 2)
                                }
                                <p className="team-name" data-tip={teamName(match?.team2_id)}>{teamName(match?.team2_id)}</p>
                              </div>
                            </div>
                          </SortableItem>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            </SortableList>
            {
              division &&
              division.length > 0 &&
              <div className="division-info">
                {
                  division.map((dv, i) => (
                    <div className="division-inner" key={`division-${i}`}>
                      <h3>{dv.name}</h3>
                      <ul>
                        {
                          dv.team_ids &&
                          dv.team_ids.split(',').map((team, index) => (
                            <li key={`${team}-${index}`}>{teamName(team)}</li>
                          ))
                        }
                      </ul>
                    </div>
                  ))
                }
              </div>
            }
          </div>
        </div>
      }
      {
        errorMessage &&
        errorMessage !== '' &&
        <div className="matchup-location schedule-create-block">
          <div className="no-record">
            <h3>
              {errorMessage}
            </h3>
          </div>
        </div>
      }
      <WarningDialogue
        isOpen={openWarningPopup}
        header={popUpContent.header}
        description={popUpContent.description}
        icon={popUpContent.icon}
        action={popUpContent.action}
        onClose={() => { setOpenWarningPopup(false); }}
      />
    </>
  );
}

export default withRouter(MatchupLocations);
